import dayjs from "dayjs";
import { useState } from "react";
import { v4 as uuid } from "uuid";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { createBlockOff } from "../../../../../actions";
import { useAppDispatch } from "../../../../../store/hooks";
import { Button } from "../../../../../components/button/button";
import { AddBlockOffModalStyled } from "./add-blockoff-modal.styles";
import { addNotification } from "../../../../../store/slices/ui-slice";
import DialogComponent from "../../../../../components/dialog-component/dialog-component";
import SelectFormField from "../../../../../components/form-fields/select-field/select-form-field";
import TextInputFormField from "../../../../../components/form-fields/text-input-field/text-input-form-field";
import { TimePickerFormField } from "../../../../../components/form-fields/time-picker-field/time-picker-field";
import { DateRangePickerFormField } from "../../../../../components/form-fields/date-range-picker/date-range-picker";
import { convertTo24HourFormat, RepeatingIntervals } from "../blockoffs.utils";
import { yupResolver } from "@hookform/resolvers/yup";
import { addBlockOffsValidationSchema } from "../../../../../utils/validations";

const AddBlockOffModal = ({
  selectedDate,
  onClose,
  updateBlockoffs,
  providersAppointmentData,
}: any) => {
  const dispatch = useAppDispatch();
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<any>({
    resolver: yupResolver(addBlockOffsValidationSchema),
  });
  const [isLoading, setIsLoading] = useState(false);

  const onAddBlockOff = async (values: any) => {
    setIsLoading(true);
    try {
      const startDate = values.start_date
        ? dayjs(values.start_date).format("YYYY-MM-DD")
        : "";
      const endDate = values.end_date
        ? dayjs(values.end_date).format("YYYY-MM-DD")
        : "";
      const startTime = values?.start_time
        ? convertTo24HourFormat(values.start_time)
        : "";
      const endTime = values?.end_time
        ? convertTo24HourFormat(values.end_time)
        : "";
      const payload = {
        start_date: startDate,
        // end_date: isSomething(values.repeat_interval) ? endDate : "",
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        title: values.title || "",
        notes: values.notes || "",
        repeat_exceptions: values.repeat_exceptions || [],
        repeat_interval: values.repeat_interval || "",
        blocked: true,
        provider: values?.add_for,
      };

      console.log({ payload });
      await createBlockOff(payload);

      if (onClose) onClose();
      await updateBlockoffs();
    } catch (error: any) {
      console.log([error]);

      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message: error.response?.data?.message || "Failed to create blockoff",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogComponent
      open
      title="Add blockoff"
      content={
        <AddBlockOffModalStyled>
          <>
            <Box className="fields-wrapper">
              <SelectFormField
                placeholder="Please enter appoitment for"
                name="add_for"
                label="Add For"
                control={control}
                options={providersAppointmentData?.map((x: any) => {
                  return {
                    label: x?.display_name,
                    value: x?.actor_id,
                  };
                })}
              />
              <TextInputFormField
                name="title"
                label="Title"
                control={control}
                placeholder="Please enter title"
              />
            </Box>
            <Box className="fields-wrapper">
              <DateRangePickerFormField
                name="start_date"
                label="Start Date"
                control={control}
                defaultValue={selectedDate}
                placeholder='Please enter start date'
              />
              <DateRangePickerFormField
                name="end_date"
                label="End Date"
                control={control}
                defaultValue={selectedDate}
                placeholder='Please enter end date'
              />
            </Box>
            <Box className="fields-wrapper">
              <TimePickerFormField
                name="start_time"
                label="Start Time"
                control={control}
                placeholder='Please enter start time'

              />
              <TimePickerFormField
                name="end_time"
                label="End Time"
                control={control}
                placeholder='Please enter end time'

              />
            </Box>
            <Box
            // className={`${!isSomething(repeatInterval) ? "" : "fields-wrapper"} `}
            >
              <SelectFormField
                name="repeat_interval"
                label="Repeatng"
                control={control}
                options={RepeatingIntervals}
                defaultValue={""}
              />
              {/* {isSomething(repeatInterval) && (
                  <DateRangePickerFormField
                    name="end_date"
                    label="End Date"
                    control={control}
                    defaultValue={selectedDate}
                  />
                )} */}
            </Box>
            <Button
              onClick={handleSubmit(onAddBlockOff)}
              isLoading={isLoading}
              disabled={isLoading || !isValid}
            >
              Add blockoff
            </Button>
          </>
        </AddBlockOffModalStyled>
      }
      onClose={onClose}
    />
  );
};

export default AddBlockOffModal;
